import Loadable from "react-loadable";

const LazyMatrice = Loadable({
  loader: () => import(/* webpackChunkName: 'comite-carrire-matrice' */ "./index"),
  loading: () => 'loading...'
});

export default LazyMatrice;
